<!-- 封装VanFieldCheckbox多选组件 -->
<template>
  <div>
    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-checkbox-group
            v-model="checkboxList"
            ref="checkboxGroup"
            direction="horizontal"
            @change="changeValue"
          >
            <div v-if="checkedShow">
              <van-checkbox
                v-for="(item, index) in dataSource"
                :key="index"
                class="wrap"
                :name="item"
                shape="square"
                :disabled="canNotCheck(item)"
                :label-disabled="true"
              >
                <div>
                  <slot name="head" :item="item" :index="index">
                    <div class="top">
                      <!-- <div class="icon"></div> -->
                      <div
                        class="title"
                        style="width: 2.86rem; margin-left: 0.12rem"
                        v-if="!columns.subtitleKey"
                      >
                        {{ checkValue(item[columns.titleKey]) }}
                      </div>
                      <div
                        class="title"
                        style="width: 2.86rem; margin-left: 0.12rem"
                        v-if="columns.subtitleKey"
                      >
                        {{ checkValue(item[columns.titleKey]) }}|{{
                          checkValue(item[columns.subtitleKey])
                        }}
                      </div>
                      <div
                        class="spot"
                        v-if="columns.operation"
                        @click.stop="operationShow(item)"
                      >
                        <img src="../../assets/diandian.png" alt="" />
                      </div>
                    </div>
                  </slot>
                  <slot name="body" :item="item" :index="index">
                    <div class="center">
                      <div>
                        <p
                          v-for="(items, indexs) in columns.content
                            ? columns.content.slice(0, minLen)
                            : []"
                          :key="indexs"
                        >
                          <span class="key" v-if="items.name == '展示批次'"
                            >批次编号：</span
                          >
                          <span class="value" v-if="items.name == '展示批次'">
                            <!-- <batch-production :code="item[items.key[0]]" :id="item[items.key[1]]"></batch-production> -->
                            <span
                              style="color:#1890ff"
                              @click.stop="showBatch(item[items.key[1]])"
                              >{{ item[items.key[0]] || "--" }}</span
                            >
                          </span>
                          <span class="key" v-if="items.name != '展示批次'"
                            >{{ items.name }}：</span
                          >
                          <span class="value" v-if="items.name != '展示批次'">
                            <span v-for="(e, v) in items.key" :key="v">{{
                              checkValue(item[e])
                            }}</span>
                          </span>
                          <span
                            @click.stop="changeContentShow(index, false)"
                            v-if="
                              indexs == minLen - 1 &&
                                columns.content.length > minLen &&
                                item.contentShow
                            "
                            class="arrow"
                            >收起
                            <van-icon name="arrow-up" />
                          </span>
                          <span
                            @click.stop="changeContentShow(index, true)"
                            v-if="
                              indexs == minLen - 1 &&
                                columns.content.length > minLen &&
                                !item.contentShow
                            "
                            class="arrow"
                            >展开
                            <van-icon name="arrow-down" />
                          </span>
                        </p>
                      </div>
                      <div
                        v-if="item.contentShow"
                        class="showAll"
                        style="
                          width: 100%;
                          margin: 0 0 0.15rem 0;
                          padding: 0.15rem 0;
                        "
                      >
                        <p
                          v-for="(items, indexs) in columns.content
                            ? columns.content.slice(
                                minLen,
                                columns.content.length
                              )
                            : []"
                          :key="indexs"
                        >
                          <span class="key" v-if="items.name == '展示批次'"
                            >批次编号：</span
                          >
                          <span class="value" v-if="items.name == '展示批次'">
                            <!-- <batch-production :code="item[items.key[0]]" :id="item[items.key[1]]"></batch-production> -->
                            <span
                              style="color:#1890ff"
                              @click.stop="showBatch(item[items.key[1]])"
                              >{{ item[items.key[0]] || "--" }}</span
                            >
                          </span>
                          <span class="key" v-if="items.name != '展示批次'"
                            >{{ items.name }}：</span
                          >
                          <span class="value" v-if="items.name != '展示批次'">
                            <span v-for="(e, v) in items.key" :key="v">{{
                              checkValue(item[e])
                            }}</span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </slot>
                  <slot name="label" :item="item" :index="index">
                    <div class="label" v-if="columns.labelKey">
                      <!-- labelText: {key: "text"}  key对应labelKey内元素 -->
                      <span v-for="(i, j) in columns.labelKey" :key="j">{{
                        `${
                          columns.labelText ? columns.labelText[i] : ""
                        }${checkValue(item[i])}`
                      }}</span>
                    </div>
                  </slot>
                  <slot name="foot" :item="item" :index="index">
                    <div
                      class="foot"
                      v-if="
                        columns.peopleKey ||
                          columns.flowStatusNameKey ||
                          columns.operationText
                      "
                    >
                      <div style="display: flex">
                        <span class="pictures" v-if="columns.peopleKey">{{
                          item[columns.peopleKey]
                            ? item[columns.peopleKey].slice(-2)
                            : ""
                        }}</span>
                        <span class="text" v-if="columns.peopleKey"
                          >由{{ item[columns.peopleKey] }}提交</span
                        >
                      </div>
                      <div
                        class="opera"
                        v-if="columns.operationText"
                        @click.stop="operationIt(item, columns.operationText)"
                      >
                        {{ columns.operationText }}
                      </div>
                      <div
                        class="opera"
                        v-if="columns.flowStatusNameKey"
                        :style="{
                          color:
                            item.flowStatus == 'RUNNING'
                              ? '#1890FF'
                              : item.flowStatus == 'TERMINATED'
                              ? '#FF943E'
                              : item.flowStatus == 'AGREE'
                              ? '#00B042'
                              : item.flowStatus == 'REFUSE'
                              ? '#FF4D4F'
                              : '#1890ff',
                        }"
                      >
                        {{ item[columns.flowStatusNameKey] }}
                      </div>
                    </div>
                  </slot>
                </div>
              </van-checkbox>
            </div>
            <div v-else>
              <div
                v-for="(item, index) in dataSource"
                :key="index"
                @click="handleItem(item)"
                class="wrap"
              >
                <div>
                  <slot name="head" :item="item" :index="index">
                    <div class="top">
                      <div class="icon"></div>
                      <div class="title" v-if="!columns.subtitleKey">
                        {{ checkValue(item[columns.titleKey]) }}
                      </div>
                      <div class="title" v-if="columns.subtitleKey">
                        {{ checkValue(item[columns.titleKey]) }}|{{
                          checkValue(item[columns.subtitleKey])
                        }}
                      </div>
                      <div
                        class="spot"
                        v-if="columns.operation"
                        @click.stop="operationShow(item)"
                      >
                        <img src="../../assets/diandian.png" alt="" />
                      </div>
                    </div>
                  </slot>
                  <slot name="body" :item="item" :index="index">
                    <div class="center">
                      <div>
                        <p
                          v-for="(items, indexs) in columns.content
                            ? columns.content.slice(0, minLen)
                            : []"
                          :key="indexs"
                        >
                          <span class="key" v-if="items.name == '展示批次'"
                            >批次编号：</span
                          >
                          <span class="value" v-if="items.name == '展示批次'">
                            <!-- <batch-production :code="item[items.key[0]]" :id="item[items.key[1]]"></batch-production> -->
                            <span
                              style="color:#1890ff"
                              @click.stop="showBatch(item[items.key[1]])"
                              >{{ item[items.key[0]] || "--" }}</span
                            >
                          </span>
                          <span class="key" v-if="items.name != '展示批次'"
                            >{{ items.name }}：</span
                          >
                          <!--change by gongjiuhui start-->
                          <span
                            class="value"
                            :style="items.style"
                            v-if="
                              items.key.length < 2 && items.name != '展示批次'
                            "
                          >
                            <span v-for="(e, v) in items.key" :key="v">{{
                              checkValue(item[e])
                            }}</span>
                          </span>
                          <span
                            class="value"
                            :style="items.style"
                            v-if="
                              items.key.length > 1 && items.name != '展示批次'
                            "
                          >
                            <span v-for="(e, v) in items.key" :key="v"
                              >{{ checkValue(item[e])
                              }}<span v-if="v != items.key.length - 1">{{
                                items.keySymbol
                              }}</span></span
                            >
                          </span>
                          <!--change by gongjiuhui end-->
                          <span
                            class="arrow"
                            @click.stop="changeContentShow(index, false)"
                            v-if="
                              indexs == minLen - 1 &&
                                columns.content.length > minLen &&
                                item.contentShow
                            "
                            >收起
                            <van-icon name="arrow-up" />
                          </span>
                          <span
                            class="arrow"
                            @click.stop="changeContentShow(index, true)"
                            v-if="
                              indexs == minLen - 1 &&
                                columns.content.length > minLen &&
                                !item.contentShow
                            "
                            >展开
                            <van-icon name="arrow-down" />
                          </span>
                        </p>
                      </div>
                      <div v-if="item.contentShow" class="showAll">
                        <p
                          v-for="(items, indexs) in columns.content
                            ? columns.content.slice(
                                minLen,
                                columns.content.length
                              )
                            : []"
                          :key="indexs"
                        >
                          <span class="key" v-if="items.name == '展示批次'"
                            >批次编号：</span
                          >
                          <span class="value" v-if="items.name == '展示批次'">
                            <!-- <batch-production :code="items.key[0]" :id="items.key[1]"></batch-production> -->
                            <span
                              style="color:#1890ff"
                              @click.stop="showBatch(item[items.key[1]])"
                              >{{ item[items.key[0]] || "--" }}</span
                            >
                          </span>
                          <span class="key" v-if="items.name != '展示批次'"
                            >{{ items.name }}：</span
                          >
                          <span class="value" v-if="items.name != '展示批次'">
                            <span v-for="(e, v) in items.key" :key="v">{{
                              checkValue(item[e])
                            }}</span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </slot>
                  <slot name="label" :item="item" :index="index">
                    <div class="label" v-if="columns.labelKey">
                      <!-- labelText: {key: "text"}  key对应labelKey内元素 -->
                      <span v-for="(i, j) in columns.labelKey" :key="j">{{
                        `${
                          columns.labelText ? columns.labelText[i] : ""
                        }${checkValue(item[i])}`
                      }}</span>
                    </div>
                  </slot>
                  <slot name="foot" :item="item" :index="index">
                    <div
                      class="foot"
                      v-if="
                        columns.peopleKey ||
                          columns.flowStatusNameKey ||
                          columns.operationText
                      "
                    >
                      <div style="display: flex">
                        <span class="pictures" v-if="columns.peopleKey">{{
                          item[columns.peopleKey]
                            ? item[columns.peopleKey].slice(-2)
                            : ""
                        }}</span>
                        <span class="text" v-if="columns.peopleKey"
                          >由{{ item[columns.peopleKey] }}提交</span
                        >
                      </div>
                      <div
                        class="opera"
                        v-if="columns.operationText"
                        @click.stop="operationIt(item, columns.operationText)"
                      >
                        {{ columns.operationText }}
                      </div>
                      <div
                        class="opera"
                        v-if="columns.flowStatusNameKey"
                        :style="{
                          color:
                            item.flowStatus == 'RUNNING'
                              ? '#1890FF'
                              : item.flowStatus == 'TERMINATED'
                              ? '#FF943E'
                              : item.flowStatus == 'AGREE'
                              ? '#00B042'
                              : item.flowStatus == 'REFUSE'
                              ? '#FF4D4F'
                              : '#1890ff',
                        }"
                      >
                        {{ item[columns.flowStatusNameKey] }}
                      </div>
                    </div>
                  </slot>
                </div>
              </div>
            </div>
          </van-checkbox-group>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- <div v-if="checkedShow" style="height: 0.5rem"></div> -->
    <div class="operation" v-if="checkedShow">
      <div>
        <img
          @click="changeItem(true)"
          v-if="checkboxList.length == 0"
          style="width: 0.2rem; height: 0.2rem; margin-top: -0.05rem"
          src="../../assets/btna.png"
          alt=""
        />
        <img
          @click="changeItem(true)"
          v-if="
            checkboxList.length !== 0 &&
              checkboxList.length !== dataSource.length
          "
          style="width: 0.22rem; height: 0.22rem; margin-top: -0.05rem"
          src="../../assets/btnb.png"
          alt=""
        />
        <!-- 勾选 -->
        <img
          @click="changeItem(false)"
          v-if="
            checkboxList.length !== 0 &&
              checkboxList.length === dataSource.length
          "
          style="width: 0.22rem; height: 0.22rem; margin-top: -0.05rem"
          src="../../assets/btnc.png"
          alt=""
        />
        <span style="margin-left: 0.05rem">
          {{ checkedShowText }}{{ checkboxList.length }}/{{
            dataSource.length
          }}</span
        >
      </div>
      <div
        class="btncancel"
        v-if="cancelOperationTxt"
        @click="getListValue('cancel')"
      >
        {{ cancelOperationTxt }}
      </div>
      <div class="singel-info" @click="getListValue" v-if="singelInfo">
        {{ operationTxt }}
      </div>
      <div class="info" @click="getListValue" v-else>{{ operationTxt }}</div>
    </div>
    <van-action-sheet v-model="actionShow" title="请选择">
      <div
        class="actionWrap"
        v-for="(item, index) in columns.operation"
        :key="index"
      >
        <div class="left"><img :src="item.icon" alt="" /></div>
        <div class="right" @click="operationIt(itemData, item.name)">
          <p class="handle" :style="{ color: item.color || '#191F25' }">
            {{ item.name }}
          </p>
          <p class="explain">{{ item.remarks }}</p>
        </div>
      </div>
    </van-action-sheet>
    <BatchProductionModal ref="BatchProductionModal"></BatchProductionModal>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import BatchProductionModal from "@/components/BatchProductionModal";
export default {
  name: "pageList",
  components: { BatchProductionModal },
  props: {
    columns: {
      type: Object,
      default: function() {
        return {};
      },
    },
    isPage: {
      type: Boolean,
      default: true,
    }, //是分页
    singelInfo: {
      type: Boolean,
      default: false,
    }, //多选时底部只有确定样式按钮
    checkedShow: {
      type: Boolean,
      default: false,
    }, //是否开启选择
    checkedShowText: {
      type: String,
      default: "已选",
    }, //是否开启选择
    operationTxt: {
      type: String,
      default: "确定",
    },
    cancelOperationTxt: {
      type: String,
      default: "",
    },
    listUrl: {
      type: String,
      default: "",
    },
    minLen: {
      type: Number,
      default: 2,
    },
    pageSize: {
      type: Number,
      default: 30, //条数
    },
  },
  computed: {},
  data() {
    return {
      actionShow: false, //底部操作开关
      checkboxList: [], //列表选中的数据
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 1, //页码
      queryParam: {}, //查询条件
      dataSource: [], //列表数据
      total: "", //列表总条数
      itemData: {},
    };
  },
  created() {},
  methods: {
    showBatch(id) {
      this.$refs.BatchProductionModal.getData(id);
    },
    // 判断是否为空
    checkValue(v) {
      if (v ?? "" !== "") {
        return v;
      } else {
        return v === 0 ? v : "--";
      }
    },
    // 动态禁用复选框
    canNotCheck(item) {
      if (this.columns.dynamicChecked) {
        return this.$parent.canNotCheck(item);
      }
    },
    changeValue(v) {
      console.log(v);
      if (v.length === this.dataSource.length) {
      } else {
      }
    },
    // 更多操作
    operationShow(v) {
      // console.log(v, "更多操作");
      this.$emit("handleList", v.id, v, "更多操作");
      if (this.columns.operation.length > 0) {
        this.actionShow = true;
      } else {
        this.$toast("当前数据暂无操作");
      }
      this.itemData = v;
    },
    // 操作事件
    operationIt(a, b) {
      // console.log(a, b, "操作事件");
      this.actionShow = false;
      this.$emit("operationItem", a, b);
    },
    handleItem(v) {
      // console.log(v, "点击整个列表");
      this.$emit("handleList", v.id, v, "列表");
    },
    // 控制展开收起
    changeContentShow(a, b) {
      console.log(a, b);
      this.dataSource[a].contentShow = b;
      this.$forceUpdate();
    },
    // 全选点击事件
    getListValue(cancel) {
      let ids =
        this.checkboxList
          .map((e) => {
            return e.id;
          })
          .toString() || "";
      if (cancel) {
        this.$emit("getCheckedValue", ids, this.checkboxList, cancel);
      } else {
        this.$emit("getCheckedValue", ids, this.checkboxList);
      }
    },
    // 控制全选、清空
    changeItem(v) {
      if (this.columns.dynamicChecked) {
        // canCheckedNum: 未被禁用的复选框数量
        // 已选中数量等于可选复选框数量时就可以清空了
        if (this.checkboxList.length == this.columns.canCheckedNum) {
          this.$refs.checkboxGroup.toggleAll(false);
        } else {
          // 全部选中，并跳过禁用的复选框
          this.$refs.checkboxGroup.toggleAll({
            checked: true,
            skipDisabled: true,
          });
        }
      } else {
        // 默认操作
        this.$refs.checkboxGroup.toggleAll(v);
      }
    },
    // 获取列表数据
    onLoad(pageNo) {
      if (!this.listUrl) {
        this.$toast("请设置url.list属性!");
        return;
      }
      if (pageNo === 1) {
        this.pageNo = 1;
        this.dataSource = [];
      }
      if (this.refreshing) {
        this.dataSource = [];
        this.refreshing = false;
      }
      let par = {
        ...this.queryParam,
        ...{ pageNo: this.pageNo, pageSize: this.pageSize },
      };
      this.loading = true;
      getAction(this.listUrl, par)
        .then((res) => {
          if (res.code == 200) {
            if (res.result.pageList) {
              let dataList = res.result.pageList.records;
              this.dataSource = [...this.dataSource, ...dataList];
              this.dataSource = this.dataSource.map((e) => {
                e.contentShow = false;
                return e;
              });
              if (this.dataSource.length === res.result.pageList.total) {
                this.finished = true;
              } else {
                this.pageNo += 1;
              }
            } else {
              if (this.isPage == false) {
                let dataList = res.result.records || res.result;
                this.dataSource = [...this.dataSource, ...dataList];
                this.finished = true;
              } else {
                this.$emit("listTotal", res.result.total);
                let dataList = res.result.records || res.result;
                this.dataSource = [...this.dataSource, ...dataList];
                this.dataSource = this.dataSource.map((e) => {
                  e.contentShow = false;
                  return e;
                });
                if (this.dataSource.length === res.result.total) {
                  this.finished = true;
                } else {
                  if (!res.result.total) {
                    this.finished = true;
                    return;
                  }
                  this.pageNo += 1;
                }
              }
            }
            this.$emit("listData", this.dataSource);
            this.loading = false;
          } else {
            this.$toast(res.message);
            this.loading = false;
            this.finished = true;
          }
        })
        .catch((e) => {
          this.loading = false;
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.checkboxList = [];
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad(1);
    },
    // 搜索
    searchQuery(v) {
      this.queryParam = v;
      this.onRefresh();
    },
    // 重置
    searchReset() {
      this.queryParam = {};
      this.onRefresh();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.list {
  .wrap {
    // min-height: 0.5rem;
    background: #fff;
    margin-top: 0.12rem;
    padding: 0.15rem;
    width: 100vw;
    .top {
      display: flex;
      justify-content: flex-start;
      .icon {
        width: 0.03rem;
        height: 0.16rem;
        background: #1890ff;
        margin-top: 0.03rem;
        margin-right: 0.1rem;
      }
      .title {
        width: 3.1rem;
        margin-right: 0.1rem;
        // height: 0.16rem;
        font-size: 0.16rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #191f25;
        // line-height: 0.23rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .spot img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
    .center {
      p {
        margin: 0.08rem 0.125rem;
        font-size: 0.14rem;
        display: flex;
        position: relative;
        .key {
          color: #888888;
        }
        .value {
          color: #191f25;
          width: 1.9rem;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .arrow {
          color: #1890ff;
          // float: right;
          // margin-right: -0.05rem;
          // display: block;
          position: absolute;
          right: -0.05rem;
        }
      }
      .showAll {
        background: #f5f8ff;
        width: 100vw;
        margin-left: -0.15rem;
        padding: 0.15rem;
        margin-bottom: 0.15rem;
      }
    }
    .label {
      margin-left: -0.03rem;
      margin-top: -0.1rem;
      span {
        height: 0.16rem;
        background: #f0f6fe;
        color: #1890ff;
        margin-right: 0.1rem;
        padding: 0.03rem 0.08rem;
        font-size: 0.11rem;
        border-radius: 0.03rem;
      }
    }
    .foot {
      // height: 0.33rem;
      // line-height: 0.33rem;
      display: flex;
      justify-content: space-between;
      // margin: 0.15rem 0.12rem 0 0.12rem;
      font-size: 0.14rem;
      .pictures {
        width: 0.33rem;
        height: 0.33rem;
        line-height: 0.33rem;
        text-align: center;
        color: #fff;
        background: #1890ff;
        display: block;
        border-radius: 0.06rem;
        font-size: 0.12rem;
        margin-right: 0.1rem;
      }
      .text {
        width: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .opera {
        color: #1890ff;
        font-size: 0.14rem;
      }
    }
  }
}
// 全选样式
.operation {
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
  position: fixed;
  bottom: 0;
  background: #ffff;
  z-index: 9;
  display: flex;
  justify-content: space-between;
  padding: 0 0.15rem;
  font-size: 0.14rem;
  font-weight: 500;
  color: #191f25;
  .info {
    width: 1rem;
    height: 0.39rem;
    line-height: 0.39rem;
    text-align: center;
    color: #fff;
    background: #1890ff;
    border-radius: 0rem;
    font-size: 0.16rem;
    margin-top: 0.06rem;
  }
  .singel-info {
    width: 100%;
    height: 0.39rem;
    line-height: 0.39rem;
    text-align: center;
    color: #fff;
    background: #1890ff;
    border-radius: 0rem;
    font-size: 0.16rem;
    margin-top: 0.06rem;
  }
  .btncancel {
    width: 1rem;
    height: 0.39rem;
    line-height: 0.39rem;
    text-align: center;
    background: #f6f6f6;
    border-radius: 0rem;
    font-size: 0.16rem;
    margin-top: 0.06rem;
  }
}
// 底部操作弹窗样式
.actionWrap {
  display: flex;
  justify-content: flex-start;
  padding: 0.15rem;
  .left {
    // background: #000;
    width: 0.2rem;
    height: 0.2rem;
    margin-right: 0.1rem;
    img {
      width: 0.2rem;
      height: 0.2rem;
    }
  }
  .right {
    flex: 1;
    p {
      margin: 0;
    }
    .handle {
      color: #191f25;
      font-size: 0.16rem;
    }
    .explain {
      color: #888888;
      font-size: 0.14rem;
    }
  }
}
</style>
